import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const bufferRecipeCalculatorTool: Tool = {
  id: "buffer-recipe-calculator",
  name: () => m.buf_tool_name(),
  description: () => m.buf_tool_description(),
  icon: "🧫",
  basePath: "/buffer-recipe-calculator",
  status: "stable",
  tags: [
    "science",
    "lab",
    "buffer",
    "western-blot",
    "tbs",
    "pbs",
    "buffer-recipe-calculator",
  ],
};
